const types ={
  construction: "الإنشاءات",
  emergency: "الطوارئ",
  maintenance: "الصيانة",
  rehabilitation_work: "أعمال التأهيل",
  special_projects: "المشاريع الخاصة"
}

export default types